import actionTypes, {Background} from "./pageActionTypes";

const initialState = {
   background: Background.DEFAULT
};

export default function changeBackground(state = initialState, action) {
    if (action.type === actionTypes.CHANGE_BACKGROUND) {
        const {payload} = action;
        return {
            ...state,
            background: payload
        };
    } else {
        return state;
    }
}
